var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 134,
    viewBox: "0 0 140 134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35732",
    "data-name": "Group 35732",
    transform: "translate(-681 -207)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19497",
    "data-name": "Rectangle 19497",
    width: 140,
    height: 134,
    rx: 6,
    transform: "translate(681 207)",
    fill: "#eff0f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35731",
    "data-name": "Group 35731",
    transform: "translate(681 206.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_538",
    "data-name": "Ellipse 538",
    cx: 16,
    cy: 16.5,
    rx: 16,
    ry: 16.5,
    transform: "translate(54 30.357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23261",
    "data-name": "Path 23261",
    d: "M31.744,0C49.276,0,63.488,12,63.488,26.8S0,41.6,0,26.8,14.212,0,31.744,0Z",
    transform: "translate(38.256 66.743)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.bba32c00c4aa2faf6c98763aa767c229.svg";
export { ForwardRef as ReactComponent };